import { createBaseStringSet } from '@sendbird/uikit-react-native';
import { it } from 'date-fns/locale';
import { formatChatDaySeparator } from '@shared/utils/formatChatDaySeparator';

const StringSetIt = createBaseStringSet({ dateLocale: it });

const generateLocalizationConfig = (t: (key: string) => string) => {
    return {
        ...StringSetIt,
        LABELS: {
            ...StringSetIt.LABELS,
            CHANNEL_INPUT_ATTACHMENT_CAMERA_PHOTO: t('screens.chat.takeAPhoto'),
            CHANNEL_INPUT_ATTACHMENT_CAMERA_VIDEO: t('screens.chat.takeAVideo'),
            CHANNEL_INPUT_ATTACHMENT_PHOTO_LIBRARY: t('screens.chat.photoLibrary'),
            CHANNEL_INPUT_ATTACHMENT_FILES: t('screens.chat.files'),
            CHANNEL_INPUT_PLACEHOLDER_ACTIVE: t('screens.chat.msgInputPlaceholder'),
            CHANNEL_MESSAGE_COPY: t('screens.chat.copyMsg'),
            CHANNEL_MESSAGE_EDIT: t('screens.chat.editMsg'),
            CHANNEL_MESSAGE_DELETE: t('screens.chat.deleteMsg'),
            CHANNEL_MESSAGE_REPLY: t('screens.chat.replyMsg'),
            CHANNEL_MESSAGE_SAVE: t('screens.chat.saveMsg'),
            CHANNEL_MESSAGE_DELETE_CONFIRM_TITLE: t('screens.chat.confirmDeleteMsgTitle'),
            CHANNEL_MESSAGE_DELETE_CONFIRM_CANCEL: t('screens.chat.cancelDeleteMsg'),
            CHANNEL_MESSAGE_DELETE_CONFIRM_OK: t('screens.chat.confirmDeleteMsg'),
        },
        GROUP_CHANNEL_LIST: {
            ...StringSetIt.GROUP_CHANNEL_LIST,
            DIALOG_CHANNEL_LEAVE: t('screens.chat.leaveChannel'),
            DIALOG_CHANNEL_NOTIFICATION: () => t('screens.chat.changeChannelNotificationsState'),
        },
        GROUP_CHANNEL: {
            ...StringSetIt.GROUP_CHANNEL,
            MESSAGE_BUBBLE_EDITED_POSTFIX: t('screens.chat.edited'),
            LIST_DATE_SEPARATOR: (date: Date) =>
                formatChatDaySeparator(date, { today: t('screens.chat.today'), yesterday: t('screens.chat.yesterday') }),
        },
    };
};

export { generateLocalizationConfig };
